import { module as Module } from "modujs";
import Lenis from "lenis";

import { $html } from "../utils/dom";

const LERP = 0.3;
export default class extends Module {
  constructor(m) {
    super(m);
  }

  init() {
    this.$wrapper = this.el.parentNode;
    this.lenis = new Lenis({
      wrapper: this.$wrapper,
      content: this.el,
      smoothWheel: true,
      syncTouch: true,
      duration: 1,
      lerp: LERP,
      syncTouchLerp: LERP,
      prevent: () => $html.classList.contains("has-menu-opened"),
    });
    window.scrollObjectInstance = this.lenis;

    this.raf(0);
  }

  raf(time) {
    this.lenis.raf(time);
    this.rafInstance = requestAnimationFrame((time) => this.raf(time));
  }

  destroy() {
    super.destroy();
    this.lenis?.destroy();
    cancelAnimationFrame(this.rafInstance);
  }
}
